import { createSlice } from '@reduxjs/toolkit';

import {
  getEmployeeDetails,
  getEmploymentDetails,
} from 'src/Member/utils/common';

export const memberSlice = createSlice({
  name: 'members',
  initialState: {
    employeeInfo: {},
    dependentsInfo: {},
    familyMember: {},
    contactDetails: {},
    loggedInUserOID: '',
    employmentDetails: {},
    loggedInMemberType: '',
    memberSummaryStatus: '',
    MemberStatePreserve: {
      coverageSummary: [],
      accumulatorSummary: [],
    },
    networkListWithMasterId: [],
    coverageFilter: {},
    viewMember: {},
  },
  reducers: {
    setMemberSummarySuccess: (state, { payload }) => {
      const isMemberDetailsLoaded = payload.isMemberDetail;

      if (isMemberDetailsLoaded) {
        state.contactDetails = payload.Response.Member?.ContactDetails || {};
        state.employmentDetails = getEmploymentDetails(payload.Response.Member);
      } else {
        state.loggedInUserOID = payload.Response.Member.LoggedInUserOID;
        state.loggedInMemberType = payload.Response.Member.LoggedInMemberType;
      }

      state.memberSummaryStatus = 'FULFILLED';
      state.isMemberDetailsLoaded = isMemberDetailsLoaded;
      state.employeeInfo = getEmployeeDetails(payload.Response.Member);
      if (isMemberDetailsLoaded) {
        state.familyMember = payload.Response.Member?.DependentsInfo || {};
      } else {
        state.dependentsInfo = payload.Response.Member?.DependentsInfo || {};
      }
    },

    setViewMemberInformationSuccess: (state, { payload }) => {
      state.viewMember = payload.Response;
    },

    setMemberCoverageSummary: (state, action) => {
      state.MemberStatePreserve.coverageSummary = action.payload;
    },
    setMemberAccumulatorSummary: (state, action) => {
      state.MemberStatePreserve.accumulatorSummary = action.payload;
    },
    setMemberSummaryReject: (state) => {
      state.memberSummaryStatus = 'REJECTED';
    },
    setNetworkList: (state, action) => {
      state.networkListWithMasterId = [
        ...state.networkListWithMasterId,
        ...action.payload,
      ];
    },
    setCoverageFilter: (state, action) => {
      state.coverageFilter = { ...state.coverageFilter, ...action.payload };
    },
    unsetMemberSummary: (state) => {
      state.memberSummaryStatus = '';
      state.loggedInUserOID = '';
      state.loggedInMemberType = '';
      state.employeeInfo = {};
      state.dependentsInfo = {};
      state.familyMember = {};
      state.contactDetails = {};
      state.employmentDetails = {};
      state.isMemberDetailsLoaded = false;
      state.coverageFilter = {};
      state.viewMember = {};
    },
    unsetCoverageSummary: (state) => {
      state.MemberStatePreserve.coverageSummary = {};
      state.networkListWithMasterId = [];
    },
    unsetAccumulatorSummary: (state) => {
      state.MemberStatePreserve.accumulatorSummary = {};
    },
  },
  extraReducers: {},
});

export const {
  unsetMemberSummary,
  setMemberSummarySuccess,
  setViewMemberInformationSuccess,
  setMemberSummaryReject,
  setMemberCoverageSummary,
  unsetCoverageSummary,
  setMemberAccumulatorSummary,
  unsetAccumulatorSummary,
  setNetworkList,
  setCoverageFilter,
} = memberSlice.actions;

export default memberSlice.reducer;
